import React from 'react';
import { UserProfile } from '@clerk/clerk-react';
import Box from '@mui/material/Box';

function ProfilePage() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <UserProfile routing="hash" />
    </Box>
  );
}

export default ProfilePage;
